
import Holidays from "date-holidays";
import dateFormat from 'dateformat';
let hd = new Holidays("CN");

/****************************************
 @name 日期相关工具方法封装
 @function isHoliday 判断日期是否为节假日
 @function isWeekend 判断日期是否为周六、日
 @function isSunday 判断日期是否为周日
 @version 2019-09-21
 ****************************************/


/** @name 假期查询缓存，减少同年份假期频繁计算
 *  @description {year:缓存的假期年份，dates:假期日期列表}
 *  @version 2019-09-21
 */
let holidaysCache = {
  year: -1,
  dates: []
}
/** @name 计算年份中对应假期日期
 *  @param {Number} year 年份,例:2019
 *  @return {Array<String>} 日期列表,例:["2019-10-01", ...]
 *  @version 2019-09-21
 */
const _getHolidays = function(year) {
  //  读取查询缓存记录
  if (holidaysCache.year == year) return holidaysCache.dates;
  /** 变量说明:
   *  dates: 年内所有节假日
   *  holidays: 工具包获取的节假日
   *  dayLength: 一天的毫秒数
   */
  let dates = [];
  let holidays = hd.getHolidays(year);
  let dayLength = 1 * 24 * 60 * 60 * 1000;
  //  工具包获取节假日格式处理(因为工具包节假日只获取到了节日开始日期)
  for (let holiday of holidays) {
    let oneDay = holiday.start;
    dates.push(dateFormat(oneDay, "yyyy-mm-dd"));
    //  春节、国庆 三天假，其它假日默认一天假
    if ( (holiday.name.indexOf('春节') != -1) || 
         (holiday.name.indexOf('国庆') != -1) ) {
      let secondDay = Number(holiday.start) + dayLength;
      let threeDay = Number(holiday.start) + (dayLength * 2);
      let secondDayStr = dateFormat(secondDay, "yyyy-mm-dd");
      let threeDayStr = dateFormat(threeDay, "yyyy-mm-dd");
      dates.push(secondDayStr);
      dates.push(threeDayStr);
    }
  }
  //  缓存节假日查询记录
  holidaysCache.year = year;
  holidaysCache.dates = dates;
  return dates;
}

/** @name 判断日期是否为国家法定节假日
 *  @param {Date|String} date 判断的日期
 *  @return {Boolean} {true:节假日，false:不是节假日}
 *  @version 2019-09-21
 */
export const isHoliday = function(date) {
  //  参数格式处理
  if (date instanceof String) date = new Date(date);
  let year = Number(dateFormat(date, 'yyyy'));
  //  获取年内节假日日期
  let dates = _getHolidays(year);
  let datesSet = new Set(dates);
  //  判断当前日期是否为节假日
  let dateStr = dateFormat(date, 'yyyy-mm-dd');
  return datesSet.has(dateStr);
}

/** @name 判断日期是否为周六、周日
 *  @param {Data|String} date 判断的日期
 *  @return {Boolean} {true:周末，false:非周六、日}
 *  @version 2019-09-21
 */
export const isWeekend = function(date) {
  //  参数格式处理
  if (date instanceof String) date = new Date(date);
  // 获取日期为星期中的第几天
  let day = date.getDay();
  // {0:周日, 6:周六}
  return (day === 0) 
      || (day === 6);
}

/** @name 判断日期是否为周日
 *  @param {Data|String} date 判断的日期
 *  @return {Boolean} {true:周日，false:非周日}
 *  @version 2019-09-22
 */
export const isSunday = function(date) {
  //  参数格式处理
  if (date instanceof String) date = new Date(date);
  // 获取日期为星期中的第几天
  let day = date.getDay();
  // {0:周日}
  return (day === 0);
}



// WEBPACK FOOTER //
// ./src/utils/date_utils.js